import { ReactNode } from 'react';

import { Box } from '../box/box';

export const PageContainer = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '20px 24px 24px',
      overflow: 'hidden',
      '& > :last-child': { flex: 1, minHeight: 0, minWidth: 0 },
    }}
  >
    {children}
  </Box>
);

export const fillCardSx = {
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
} as const;
